import { useI18n } from "@/i18n";

const TechSpecs = () => {
  const { language } = useI18n();

  const modelStats = language === 'en' ? [
    { value: '262K', label: 'Context', sublabel: 'Token context window' },
    { value: '201', label: 'Languages', sublabel: 'Natively supported' },
  ] : [
    { value: '262K', label: '上下文', sublabel: 'Token 上下文窗口' },
    { value: '201', label: '种语言', sublabel: '原生支持' },
  ];

  const platformStats = language === 'en' ? [
    { value: '<1ms', label: 'Search', sublabel: 'Vector search latency' },
    { value: '100%', label: 'Offline', sublabel: 'No internet required' },
    { value: 'MLX', label: 'Engine', sublabel: 'Metal GPU acceleration' },
  ] : [
    { value: '<1ms', label: '检索', sublabel: '向量搜索延迟' },
    { value: '100%', label: '离线', sublabel: '无需联网' },
    { value: 'MLX', label: '引擎', sublabel: 'Metal GPU 加速' },
  ];

  return (
    <section className="py-24 md:py-32 bg-[#F9FAFB]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              {language === 'en' ? 'What Your Mac Can Do with Estha' : '你的 Mac 能用 Estha 做什么'}
            </h2>
            <p className="text-lg md:text-xl text-gray-500 max-w-3xl mx-auto">
              {language === 'en'
                ? 'Enterprise-grade AI inference running entirely on your Mac, optimized for M-series chips.'
                : '企业级 AI 推理完全在你的 Mac 上运行，为 M 系列芯片深度优化。'}
            </p>
          </div>

          {/* Model capabilities */}
          <div className="mb-6">
            <p className="text-center text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {language === 'en' ? 'Default Model — Qwen3.5 · More models coming soon' : '默认模型 — Qwen3.5 · 更多模型即将支持'}
            </p>
            <div className="grid grid-cols-2 gap-4 md:gap-6 max-w-md mx-auto">
              {modelStats.map((stat, i) => (
                <div
                  key={i}
                  className="bg-white rounded-2xl p-6 text-center border border-gray-100 hover:shadow-md transition-shadow duration-300"
                >
                  <div className="text-3xl md:text-4xl font-bold text-[#1E88C8] mb-1">{stat.value}</div>
                  <div className="text-sm font-semibold text-gray-900 mb-1">{stat.label}</div>
                  <div className="text-xs text-gray-400">{stat.sublabel}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Platform capabilities */}
          <div>
            <p className="text-center text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {language === 'en' ? 'Estha Platform' : 'Estha 平台'}
            </p>
            <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-2xl mx-auto">
              {platformStats.map((stat, i) => (
                <div
                  key={i}
                  className="bg-white rounded-2xl p-6 text-center border border-gray-100 hover:shadow-md transition-shadow duration-300"
                >
                  <div className="text-3xl md:text-4xl font-bold text-[#1E88C8] mb-1">{stat.value}</div>
                  <div className="text-sm font-semibold text-gray-900 mb-1">{stat.label}</div>
                  <div className="text-xs text-gray-400">{stat.sublabel}</div>
                </div>
              ))}
            </div>
          </div>

          <p className="text-center mt-8 text-sm text-gray-400">
            {language === 'en'
              ? 'Optimized for M2+ chips · Zero cloud dependency'
              : '针对 M2+ 芯片优化 · 零云端依赖'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TechSpecs;
